// @format
import React from 'react';
import styled from 'styled-components';
import imgPrint from '../assets/img/printer.png';

const PrintWrapper = styled.a`
  display: block;
  color: white;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 14px;
  box-sizing: border-box;
  text-decoration: none;
`;

const PrintIconWrapper = styled.div`
  padding-right: 14px;
  box-sizing: border-box;
`;

const PrintIcon = () => (
  <PrintIconWrapper>
    <img alt="print" src={imgPrint} />
  </PrintIconWrapper>
);

export default ({ children, href }) => (
  <PrintWrapper href={href}>
    <PrintIcon />
    {children}
  </PrintWrapper>
);
